// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"style_checkboxContainer__A45c7","checkboxLabel":"style_checkboxLabel__7bYfp"};